$(function () {
	const getcookie = $.cookie('heineken')

	if (getcookie) {
		$('.cookie-wrapper').hide()
	} else {
		$('.cookie-wrapper').show()
	}

	$('.btn-cookie').click(function (e) {
		e.preventDefault()
		APP.setScrollTopAnimation(window, 0)
	})

	$('.btn-set.close').on('click', function () {
		$('.cookie-wrapper').hide()
	})

	$('.btn-set.submit').on('click', function () {
		$.cookie('heineken', 1, { domain: window.location.hostname, path: '/' })
		$('.cookie-wrapper').hide()
	})

	$(window).on('scroll', function () {
		const posY = $(this).scrollTop()
		if (posY >= 200) {
			$('.btn-cookie').show()
		} else {
			$('.btn-cookie').hide()
		}
	})

	APP.init()
})
